import { render, staticRenderFns } from "./MenuPantallaUsuario.vue?vue&type=template&id=23d13d16"
import script from "./MenuPantallaUsuario.vue?vue&type=script&lang=js"
export * from "./MenuPantallaUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports